/**
 * Build-time feature flags.
 *
 * `NEXT_PUBLIC_*` values are inlined by Next at build time, so these must be
 * read as static member expressions — no dynamic `process.env[name]` lookups.
 *
 * Every flag defaults to OFF. A missing or misspelled variable therefore hides
 * the unfinished feature rather than exposing it, which is the safe direction
 * for production.
 */

/**
 * Gates the Reports section (`/reports` and `/pm/reports`).
 *
 * Off in production until the reporting backend replaces the mock data in
 * `features/reports/library/reportsMock.ts`. Set to `"true"` in `.env` locally
 * and in Vercel preview environments to work on the real page.
 */
export const REPORTS_ENABLED = process.env.NEXT_PUBLIC_REPORTS_ENABLED === "true";
